import React from 'react';
import { useNavigate } from 'react-router-dom';
import { ArrowRightIcon } from 'lucide-react';
import { Highlight } from './Highlight';
export function ChiroLandingPage() {
  const navigate = useNavigate();
  const handleStartNow = () => {
    navigate('/calculator');
  };
  return <div className="min-h-screen bg-white flex items-center justify-center py-6 md:py-12 px-4" data-id="element-27">
      <div className="max-w-3xl mx-auto w-full" data-id="element-28">
        {/* Main Content */}
        <div className="text-center space-y-4 md:space-y-6" data-id="element-29">
          {/* Logo */}
          <div className="animate-fade-in mb-4 md:mb-6" data-id="element-30">
            <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/qmxPrQcAoJQeBtBGYhM9D6/516lion.png" alt="516 Partners Logo" className="h-16 md:h-24 mx-auto" data-id="element-31" />
          </div>

          {/* Headlines */}
          <div className="animate-stagger-in animate-delay-100" data-id="element-32">
            {/* Small headline above */}
            <p className="text-sm sm:text-base md:text-lg font-medium text-gray-700 uppercase tracking-wide mb-2" data-id="element-33">
              Chiropractors Doing $500k+/yr...
            </p>
            {/* Main headline */}
            <h1 className="text-3xl sm:text-4xl md:text-4xl lg:text-5xl font-serif font-bold text-gray-900 leading-tight mb-2 max-w-2xl mx-auto" data-id="element-34">
              Discover What Your Private Practice is Worth in{' '}
              <Highlight data-id="element-35">60 Seconds</Highlight>
            </h1>
          </div>

          {/* Subheadline */}
          <div className="animate-stagger-in animate-delay-200" data-id="element-36">
            <p className="text-lg sm:text-xl md:text-2xl text-gray-600 mb-6" data-id="element-37">
              No
              uploads. No hassle. Completely free.
            </p>
          </div>

          {/* Chiro-specific value props */}
          <div className="max-w-xl mx-auto mb-8 animate-stagger-in animate-delay-300" data-id="element-38">
            
          </div>

          {/* Giphy GIF */}
          <div className="mb-8 md:mb-12 max-w-[200px] sm:max-w-[250px] mx-auto animate-fade-in" data-id="element-39">
            <div style={{
            width: '100%',
            height: 0,
            paddingBottom: '100%',
            position: 'relative'
          }} data-id="element-40">
              <iframe src="https://giphy.com/embed/Qdeukl13q1NS3Vi7na" width="100%" height="100%" style={{
              position: 'absolute',
              top: 0,
              left: 0
            }} frameBorder="0" className="giphy-embed" allowFullScreen title="Chiropractic Practice Valuation Preview" data-id="element-41" />
            </div>
          </div>

          {/* CTA Button */}
          <div className="animate-stagger-in animate-delay-400 mb-24 md:mb-32 lg:mb-40" data-id="element-42">
            <button onClick={handleStartNow} className="inline-flex items-center space-x-2 px-10 sm:px-12 py-4 sm:py-5 bg-yellow-500 text-gray-900 font-bold text-lg sm:text-xl hover:bg-yellow-400 focus:outline-none focus:ring-2 focus:ring-yellow-500 focus:ring-offset-2 transition-all duration-300 shadow-lg hover:shadow-xl" data-id="element-43">
              <span data-id="element-44">Get My Free Valuation</span>
              <ArrowRightIcon className="w-5 h-5 sm:w-6 sm:h-6" data-id="element-45" />
            </button>
          </div>
        </div>
      </div>
    </div>;
}